import React, { SVGProps } from 'react';
const homeFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M13.333 26.667v-8h5.333v8h6.667V16h4L16 4 2.667 16h4v10.667z" /></svg>;
export default homeFilled;